import { getRootLogger } from '@lucidlink/tscore';
import { InvalidArgumentError } from '#common/types';
export class InvalidLoggerError extends Error {
    constructor(message) {
        super(message);
    }
}
export class LoggingManager {
    loggers = {};
    getLogger(name) {
        if (name === '') {
            throw new Error(`Cannot create a logger without a name`);
        }
        const existingLogger = this.loggers[name];
        if (existingLogger) {
            return existingLogger;
        }
        const rootLoggerRef = getRootLogger();
        const newLogger = rootLoggerRef.child({ name: name }, { level: rootLoggerRef.level });
        this.loggers[name] = newLogger;
        return newLogger;
    }
    setLevel(logLevel, loggerName = '') {
        const existingLogger = this.loggers[loggerName];
        if (existingLogger) {
            existingLogger.level = logLevel;
            return;
        }
        if (loggerName !== '') {
            throw new InvalidArgumentError(`Logger with name ${loggerName} does not exist`);
        }
        getRootLogger().level = logLevel;
        for (const loggerName in this.loggers) {
            this.loggers[loggerName].level = logLevel;
        }
    }
    getRootLogLevel() {
        return getRootLogger().level;
    }
}
export const Logging = new LoggingManager();
